import { z } from 'zod';
import { FlowBlockValueStringSchema } from './stringSchema.js';
function FlowBlockValueUuidInnerSchema() {
    return FlowBlockValueStringSchema({
        stringValidationSchema: z.uuid({ message: 'Must be a valid ID.' }),
    });
}
export function FlowBlockValueUuidSchema(args = {}) {
    const { isRequired = false } = args;
    const blockValueOrUuidSchema = FlowBlockValueUuidInnerSchema();
    if (isRequired) {
        return blockValueOrUuidSchema;
    }
    return z
        .union([z.literal(''), blockValueOrUuidSchema])
        .transform((value) => value.length === 0 ? null : value);
}
//# sourceMappingURL=uuidSchema.js.map